import { useEffect, useState, memo } from "react";
import { Box, Skeleton, Typography } from "@mui/material";

import { request } from "@/Api";
import {
    StatusBadge,
    WidgetHeaderRow,
    ListRowDivider,
    ListRowItem,
} from "../primitives";
import { formatDateStringToDayMonth } from "@/utils";

const DashboardMilestones = memo(() => {
    const [milestones, setMilestones] = useState(null);

    useEffect(() => {
        request
            .get("/dashboard/milestones")
            .then((r) => setMilestones(r.data || []))
            .catch(() => setMilestones([]));
    }, []);

    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                gap: "10px",
                height: "100%",
            }}
        >
            <WidgetHeaderRow
                title="Upcoming Milestones"
                count={milestones?.length ?? null}
            />
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "4px",
                    flex: 1,
                    overflow: "auto",
                }}
            >
                {!milestones &&
                    [1, 2, 3].map((i) => (
                        <Skeleton
                            key={i}
                            variant="rounded"
                            height={44}
                            sx={{
                                borderRadius: "6px",
                                bgcolor: "action.hover",
                            }}
                        />
                    ))}
                {milestones?.map((milestone, i) => (
                    <Box
                        key={milestone.id || i}
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            gap: "4px",
                        }}
                    >
                        {i > 0 && <ListRowDivider />}
                        <ListRowItem
                            href={`/projects/${milestone.project_id}?milestone=${milestone.id}`}
                            primary={milestone.name}
                            sub1={milestone.project_name || ""}
                            right={
                                <StatusBadge
                                    label={formatDateStringToDayMonth(
                                        milestone.complete_date,
                                    )}
                                    color="grey"
                                />
                            }
                        />
                    </Box>
                ))}
                {milestones?.length === 0 && (
                    <Typography
                        sx={{
                            fontSize: 12,
                            color: "text.secondary",
                            fontFamily: "Inter Tight, sans-serif",
                            px: "8px",
                        }}
                    >
                        No upcoming milestones
                    </Typography>
                )}
            </Box>
        </Box>
    );
});

DashboardMilestones.displayName = "DashboardMilestones";

export default DashboardMilestones;
